const clientId = process.env.REACT_APP_ENTRA_CLIENT_ID;

if (!clientId) {
  throw new Error("Missing required env var: REACT_APP_ENTRA_CLIENT_ID");
}

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/organizations`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email", "offline_access", "User.Read"],
};
